enum PrefundPurchaseOptions {
    COMPLETED = 'COMPLETED PURCHASE',
    PLANNED = 'PLANNED PURCHASE',
}

export default PrefundPurchaseOptions;
